import axios from 'axios';
import CryptoJS from 'crypto-js';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { generalJournalItemsConfig } from './components/sidebar/SidebarGeneralJournalDropdown';
import { authenticate } from './features/auth/auth.slice';
import { statusChequeCountApi } from './features/notifications/cheque/cheque-count-notification.api';
import { statusTransactionsCountApi } from './features/notifications/transactions/transactions-count-notification.api';
import { setUserDetails } from './features/users/users.slice';

const Redirect = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const rawData = query.get('data');
  const queryClient = useQueryClient();

  const handleRedirect = (role, permissions) => {
    const lowerCaseRole = role.toLowerCase();

    switch (lowerCaseRole) {
      case 'requestor':
        return `/request`;

      case 'ap tagging':
        return `/document/tagging`;

      case 'gas associate':
        return `/document/transmitting`;

      case 'ap associate':
      case 'ap specialist':
        // Check for specific AP Associate/Specialist voucher path first
        // If not, then dynamically check generalJournalItemsConfig
        if (lowerCaseRole === 'ap associate' || lowerCaseRole === 'ap specialist') {
          const voucherPath = `/voucher/vouchering`;
          // You might have a permission for this specific path, if so, check it here
          // For now, assuming this is the primary path if no general journal match
          // If you have a specific permission for /voucher/vouchering, add it to 'permissions' and check here.
          // For example: if (permissions.includes(SOME_VOUCHER_PERMISSION_ID)) return voucherPath;
          return voucherPath;
        }
        // If no specific voucher path or permission, fall through to dynamic general journal check
        // This will be handled by the dynamic search logic below if a match is found.
        break;

      case 'audit associate':
        if (permissions.includes(3)) return `/audit/inspect-voucher`;
        if (permissions.includes(5)) return `/audit/chequing`;
        // If no specific audit permission is found, fall through to dynamic general journal check
        break;

      case 'treasury associate':
        if (permissions.includes(7)) return `/cheque/chequing`;
        if (permissions.includes(8)) return `/cheque/clearing`;
        if (permissions.includes(9)) return `/cheque/debiting`;
        // If no specific treasury permission is found, fall through to dynamic general journal check
        break;

      case 'executive assistant':
        return `/cheque/transmitting`;

      case 'approver':
        return '/approval';

      case 'mis':
        return '/reports/transaction-report';

      default:
        // If the role is not explicitly handled above, check generalJournalItemsConfig
        // This will also be the fallback if dynamic roles don't find a match in generalJournalItemsConfig
        break;
    }

    // Dynamic search for generalJournalItemsConfig for specific roles
    const rolesForDynamicSearch = ['treasury associate', 'audit associate', 'ap specialist', 'ap associate', 'approver'];

    if (rolesForDynamicSearch.includes(lowerCaseRole)) {
      for (const item of generalJournalItemsConfig) {
        if (permissions.includes(item.permission)) {
          return item.to; // Return the 'to' path of the first matching permission
        }
      }
    }

    // Fallback if no specific role or dynamic general journal permission is found
    return `/masterlist/users`;
  };

  useEffect(() => {
    try {
      const data = JSON.parse(decodeURIComponent(rawData));
      //console.log('data', data);
      const { token, ...user } = data?.result;
      //console.log('token', token);
      //console.log('user', user);

      const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(user), process.env.REACT_APP_SECRET_KEY).toString();

      window.localStorage.setItem('token', token);
      window.localStorage.setItem('user', encryptedUser);
      window.localStorage.setItem('has_logged_in_before', true);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.defaults.headers.common['X-Auth-Token'] = `Bearer ${token}`;

      // console.log('1. token saved to localStorage:', localStorage.getItem('token'));
      // console.log('2. about to dispatch authenticate...');
      dispatch(authenticate());

      // console.log('3. about to dispatch setUserDetails...');
      dispatch(setUserDetails(user));

      // console.log('4. user permissions:', user.permissions);
      // console.log('5. about to navigate...');

      dispatch(statusTransactionsCountApi.util.resetApiState());
      dispatch(statusChequeCountApi.util.resetApiState());
      queryClient.invalidateQueries('transactions');

      const REDIRECT = handleRedirect(user.role, user.permissions);
      navigate(REDIRECT, {
        state: {
          default_password: false,
        },
      });
    } catch (e) {
      console.log('errorrrrrrrrrrrrrrrrrrrrr', e);
      window.location.href = `https://one.rdfmis.com/`;
    }
  }, [rawData]);

  return null;
};

export default Redirect;
